import names from '@/modules/personal_account/routers/names'
import UserBase from "@/modules/personal_account/Base.vue"
import PartnersBase from "@/modules/personal_account/partners/Base.vue"
import PartnersDetail from "@/modules/personal_account/partners/pages/PartnersDetail.vue"
import MailsBase from "@/modules/personal_account/mails/Base.vue"
import MailsDetail from "@/modules/personal_account/mails/pages/MailsDetail.vue"
import PromocodesBase from "@/modules/personal_account/promocodes/Base.vue"
import InfosBase from "@/modules/personal_account/infos/Base.vue"
import FeedbacksBase from "@/modules/personal_account/feedbacks/Base.vue"
import Applications from "@/modules/personal_account/calendar/pages/Applications.vue"
import EventDetail from "@/modules/personal_account/calendar/pages/EventDetail.vue"
import Events from "@/modules/personal_account/calendar/Base.vue"
import { MENDELEEV_INSTANCE } from "@/helper/consts"

export default ([
  // {
  //   path: '/no_access',
  //   name: names.NO_ACCESS_PAGE.BASE,
  //   component: noAccessPage,
  //   meta: {
  //     requiredAuth: true,
  //     instances: [
  //       MENDELEEV_INSTANCE
  //     ]
  //   },
  //   children: []
  // },
  {
    path: '/user',
    name: names.MAIN,
    component: UserBase,
    meta: {
      breadcrumb: 'Личный кабинет',
      requiredAuth: true,
      instances: [
        MENDELEEV_INSTANCE
      ]
    },
    children: [
      {
        path: 'partners',
        name: names.PARTNER.PAGE,
        component: PartnersBase,
        meta: {
          breadcrumb: 'Партнеры',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: [
          {
            path: ':id',
            name: names.PARTNER.DETAIL,
            component: PartnersDetail,
            meta: {
              breadcrumb: 'Партнер',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
        ]
      },
      {
        path: 'mails',
        name: names.MAIL.PAGE,
        component: MailsBase,
        meta: {
          breadcrumb: 'Уведомления от партнеров',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: [
          {
            path: ':id',
            name: names.MAIL.DETAIL,
            component: MailsDetail,
            meta: {
              breadcrumb: 'Уведомление',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
        ]
      },
      {
        path: 'events',
        name: names.CALENDAR.PAGE,
        component: Events,
        meta: {
          breadcrumb: 'События',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: [
          {
            path: 'applications',
            name: names.CALENDAR.APPLICATIONS,
            component: Applications,
            meta: {
              breadcrumb: 'Записи',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
          {
            path: ':id',
            name: names.CALENDAR.DETAIL,
            component: EventDetail,
            meta: {
              breadcrumb: 'Событие',
              requiredAuth: true,
              instances: [
                MENDELEEV_INSTANCE
              ]
            },
            children: []
          },
        ]
      },
      {
        path: 'promocodes',
        name: names.PROMO.PAGE,
        component: PromocodesBase,
        meta: {
          breadcrumb: 'Промокоды',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'infos',
        name: names.INFO.PAGE,
        component: InfosBase,
        meta: {
          breadcrumb: 'Информация',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      },
      {
        path: 'feedbacks',
        name: names.FEEDBACK.PAGE,
        component: FeedbacksBase,
        meta: {
          breadcrumb: 'Обращения',
          requiredAuth: true,
          instances: [
            MENDELEEV_INSTANCE
          ]
        },
        children: []
      }
    ]
  },

])
